module.exports = __webpack_public_path__ + "static/media/sent-icon.7fe62639.svg";